module.exports = __webpack_public_path__ + "static/back_logo-86b539b0900ef51a936419c71de21282.jpg";